import { getEnvironment, ENVIRONMENTS } from '@hotjar/common';

export const mfeUrlConfig = {
  [ENVIRONMENTS.LIVE]: 'https://engage-insights-live.hotjar.com/static/dashboard',
  default: 'https://engage-insights-integration.hotjar.com/static/dashboard',
};

const localOverride = localStorage.getItem('ENGAGE_INSIGHTS_MFE_REMOTE');

export const mfeRemoteHost =
  localOverride ?? (mfeUrlConfig[getEnvironment()] || mfeUrlConfig.default);
